import { API, authClient } from "../index";

// Get coin by id
export const getCoinById = (id) => {
  return authClient().get(`${API}/coin/${id}`);
};
export const getCoins = () => {
  return authClient().get(`${API}/coin`);
};

// Create coin
export const postCoin = async (coin) => {
  return authClient().post(`${API}/coin`, coin);
};

// Update coin
export const updateCoin = async (id, coin) => {
  return authClient().put(`${API}/coin/${id}`, coin);
};
